module.exports = __webpack_public_path__ + "img/微课04.5d814577.svg";